import { CgClose } from 'react-icons/cg';
import Logo from 'assets/icons/logo.png';
import { Button } from 'components/base';
import { useNavigate } from 'react-router-dom';

const SuccessOrder = () => {
  const navigate = useNavigate();

  const toHomePage = () => {
    navigate('/', { replace: true });
  };

  return (
    <div className="flex h-screen flex-col items-center justify-between p-3">
      <button
        onClick={toHomePage}
        className="flex h-8 w-8 items-center justify-center self-start"
      >
        <CgClose color="#AAB4C8" className="text-2xl" />
      </button>

      <div className="flex flex-col items-center pb-[100px]">
        <div className="flex h-[160px] w-[160px] items-center justify-center rounded-full border-4 border-black">
          <img alt="" src={Logo} className="h-[101px] w-20" />
        </div>

        <p className="mt-10 text-center text-3xl font-semibold text-primary-light-blue">
          Thank you!
        </p>
        <p className="mt-5 text-center text-xl font-semibold text-primary-black">
          Order #7312 has been placed!
        </p>
        <p className="mt-5 text-center text-sm text-primary-grey">
          We’ve sent a link to your email with all the info we need to get your
          order started. Our team will reach out to you shortly.
        </p>

        <Button
          theme="OUTLINE"
          className="mt-[60px] w-[80%] border-primary-light-blue"
        >
          <p className="font-semibold text-primary-light-blue">
            Schedule a call
          </p>
        </Button>
        <Button theme="PRIMARY" className="mt-3 w-[80%]" onClick={toHomePage}>
          <p className="font-semibold">Back to homepage</p>
        </Button>
      </div>
    </div>
  );
};

export default SuccessOrder;
